/**
 * results Actions
 */
import { SET_RESULT } from './constants';

export function setResult(namespace, result) {
    return {
        type: SET_RESULT,
        namespace,
        result
    };
}
